module.exports = __webpack_public_path__ + "img/鹿城公安.a9db6082.png";